import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../../lib/http/index.js';
import { createSelector } from 'reselect';


export const getCobranzasData = createAsyncThunk('GET_COBRANZAS', async (payload, thunkAPI) => {
    const contratos = (await http.TABLE('/contratos')).body;
    const personas = (await http.TABLE('/personas')).body;
    const titularidades = (await http.TABLE('/titularidadcontratos')).body;
    const clasesContratos = (await http.TABLE('/clasesContrato')).body;
    const cdcTitularidades = (await http.TABLE('/titularidadcontratos-cdc')).body;
    const indices = (await http.TABLE('/indices')).body;
    const pagos = (await http.TABLE('/pagos')).body;
    const cdcContratos = (await http.TABLE('/contratos-cdc')).body;
    const campos = (await http.TABLE('/campos-cobranza')).body;
    const cvus = (await http.TABLE('/cvus')).body;
    const registros = (await http.TABLE('/registros-cobranza')).body;
    const rendiciones = (await http.TABLE('/rendiciones-cobranza')).body;
    const detallesRendicion = (await http.TABLE('/detalles-rendicion')).body;
    const instrumentosRendicion = (await http.TABLE('/instrumentos-rendicion')).body;
    const adhesionesClientesMap = (await http.TABLE('/adhesiones-clientes-map')).body;
    const clientesDebito = (await http.TABLE('/clientes-debito')).body;
    const adhesionesDebito = (await http.TABLE('/adhesiones-debito')).body;
    const ingresosDebito = (await http.TABLE('/ingresos-debito')).body;
    const detallesIngreso = (await http.TABLE('/detalles-ingreso')).body;
    const funcHistoria = (await http.GET('/funchistoriacontrato')).body;
    const tiposCampana = (await http.TABLE('/tipos-campana')).body;
    const campanas = (await http.TABLE('/campanas')).body;
    return {
        contratos,
        titularidades,
        cdcTitularidades,
        indices,
        personas,
        clasesContratos,
        pagos,
        cdcContratos,
        campos,
        registros,
        cvus,
        rendiciones,
        detallesRendicion,
        instrumentosRendicion,
        adhesionesClientesMap,
        clientesDebito,
        adhesionesDebito,
        ingresosDebito,
        detallesIngreso,
        funcHistoria,
        tiposCampana,
        campanas,
    };
});
//Cuenta Recaudadora
export const addCamposCobranza = createAsyncThunk('POST_CAMPOS_COBRANZAS', async (payload, thunkAPI) => {
    let res = (await http.POST('/campos-cobranza', payload)).body;
    await thunkAPI.dispatch(getCobranzasData()).unwrap();
    return res;
});
export const addRendicionCobranza = createAsyncThunk('POST_RENDICION_COBRANZAS', async (payload, thunkAPI) => {
    let res = (await http.POST('/rendiciones-cobranza', payload)).body;
    await thunkAPI.dispatch(getCobranzasData()).unwrap();
    return res;
});
export const addCvusCobranza = createAsyncThunk('POST_CVUS_COBRANZAS', async (payload, thunkAPI) => {
    let res = (await http.POST('/cvus', payload)).body;
    await thunkAPI.dispatch(getCobranzasData()).unwrap();
    return res;
});
//Debito directo
export const addIngresosDebito = createAsyncThunk('POST_INGRESOS_DEBITO', async (payload, thunkAPI) => {
    let res = (await http.POST('/ingresos-debito', payload)).body;
    await thunkAPI.dispatch(getCobranzasData()).unwrap();
    return res;
});
export const addAdhesionDebito = createAsyncThunk('POST_ADHESION_DEBITO', async (payload, thunkAPI) => {
    let res = (await http.POST('/adhesiones-debito', payload)).body;
    await thunkAPI.dispatch(getCobranzasData()).unwrap();
    return res;
});
export const deleteAdhesionDebito = createAsyncThunk('DELETE_ADHESION_DEBITO', async (payload, thunkAPI) => {
    let res = (await http.DELETE('/adhesiones-debito', payload)).body;
    await thunkAPI.dispatch(getCobranzasData()).unwrap();
    return res;
});
export const addClientesDebito = createAsyncThunk('POST_CLIENTES_DEBITO', async (payload, thunkAPI) => {
    let res = (await http.POST('/clientes-debito', payload)).body;
    await thunkAPI.dispatch(getCobranzasData()).unwrap();
    return res;
});
export const deleteClientesDebito = createAsyncThunk('DELETE_CLIENTES_DEBITO', async (payload, thunkAPI) => {
    let res = (await http.DELETE('/clientes-debito', payload)).body;
    await thunkAPI.dispatch(getCobranzasData()).unwrap();
    return res;
});
const initialState = {
    //pendingRequests: 0,
    fetching: 0,
    error: null,
    message: null,
    data: {}
};

const cobranzasSlice = createSlice({
    name: 'cobranzas',
    initialState,
    reducers: {
        cleanError: (state, action) => ({ ...state, error: null }),
        cleanMessage: (state, action) => ({ ...state, message: null }),
        resetData: (state, action) => ({ ...initialState }),
    },
    extraReducers: {
        [getCobranzasData.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [getCobranzasData.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getCobranzasData.fulfilled]: (state, action) => ({ ...state, data: action.payload, fetching: state.fetching - 1 }),
        //addCamposCobranza, addRendicionCobranza, addCvusCobranza, addIngresosDebito, addAdhesionDebito, deleteAdhesionDebito, addClientesDebito, deleteClientesDebito
        //Cuenta Recaudadora
        [addCamposCobranza.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addCamposCobranza.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la publicación!" }),
        [addCamposCobranza.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Publicación enviada!" : null,
            error: action.payload.status != 200 ? "No se pudo crear la publicación!" : null,
        }),
        [addRendicionCobranza.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addRendicionCobranza.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la rendición!" }),
        [addRendicionCobranza.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Rendición cargada!" : null,
            error: action.payload.status != 200 ? "No se pudo crear la rendición!" : null,
        }),
        [addCvusCobranza.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addCvusCobranza.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar el archivo de CVUS!" }),
        [addCvusCobranza.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "CVUS cargados!" : null,
            error: action.payload.status != 200 ? "No se cargar los CVUS!" : null,
        }),
        //Débito
        [addIngresosDebito.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addIngresosDebito.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar el archivo de Débito Directo!" }),
        [addIngresosDebito.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Ingresos cargados!" : null,
            error: action.payload.status != 200 ? "No se pudieron cargar los ingresos!" : null,
        }),
        [addAdhesionDebito.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addAdhesionDebito.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la adhesión!" }),
        [addAdhesionDebito.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Adhesión creada!" : null,
            error: action.payload.status != 200 ? "No se pudo crear la adhesión!" : null,
        }),
        [deleteAdhesionDebito.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [deleteAdhesionDebito.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la eliminación!" }),
        [deleteAdhesionDebito.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Adhesión eliminada!" : null,
            error: action.payload.status != 200 ? "No se pudo eliminar la adhesión!" : null,
        }),
        [addClientesDebito.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addClientesDebito.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la creación de clientes!" }),
        [addClientesDebito.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Clientes creados!" : null,
            error: action.payload.status != 200 ? "No se pudieron crear los clientes!" : null,
        }),
        [deleteClientesDebito.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, cuponesRegistro: null }),
        [deleteClientesDebito.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la eliminación!" }),
        [deleteClientesDebito.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Cliente eliminado!" : null,
            error: action.payload.status != 200 ? "No se pudo eliminar el Cliente!" : null,
        })
    },
})

export const { cleanError, cleanMessage, resetData } = cobranzasSlice.actions
export default cobranzasSlice.reducer;